<template>
  <div
    v-if="typeof this.stores !== 'undefined'"
    class="stores"
    :class="{ 'stores--loading': loading }">
    <ul>
      <li
        v-for="(store, index) of stores"
        :key="index">
        <img
          v-if="typeof backgrounds[index] !== 'undefined'"
          :src="backgrounds[index]"
          class="stores__backgrounds"
          :alt="`background ${store.fields.image.fields.description}`">
        <img 
          :src="`${store.fields.image.fields.file.url}?w=390&fit=scale`"
          :srcset="`${store.fields.image.fields.file.url}?w=390&fit=scale 1x, ${store.fields.image.fields.file.url}?w=780&fit=scale 2x`"
          width="390"
          height="261"
          :alt="store.fields.image.fields.description">
        <div>
          <h5>{{ store.fields.title }}</h5>
          <p v-html="$_getAddressFormed(store.fields.address)"></p>
          <a
            class="maps-link"
            :href="store.fields.googlemapsLink"
            target="_blank">
              Google Maps
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Stores',
  data: () => ({
    loading: true,
    backgrounds: [
      require('@/assets/home/pennellata-oderzo.png'),
      require('@/assets/home/pennellata-san-dona-di-piave.png')
    ]
  }),
  computed: {
    ...mapGetters('contentful', [
      'stores'
    ])
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadStores'
    ]),
    $_getAddressFormed (address) {
      return address.replace(/\n/g, `</br>`)
    },
    async loadData () {
      this.loading = true
      try {
        await this.loadStores()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./stores.scss";
</style>
